export const hiddenCategories = ['None', 'Padman', 'Peacock'];
